package com.kinoshazam.screens.main

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.kinoshazam.uiKit.components.textLabel.TextLabel
import com.kinoshazam.uiKit.components.textLabel.TextLabelState
import com.kinoshazam.uiKit.theme.Large
import com.kinoshazam.uiKit.theme.UiKitTheme
import kinoshazam.resources.generated.resources.Res
import kinoshazam.resources.generated.resources.favorite_sync
import org.jetbrains.compose.resources.stringResource
import presentation.screens.main.MainState

@Composable
fun FavoriteSyncStatus(
    state: MainState,
    modifier: Modifier = Modifier,
) {
    val hasLocalFavorites = !state.favoriteList.isNullOrEmpty()
    if (!state.isFavoriteSync || !hasLocalFavorites) return
    Row(
        modifier = modifier.padding(horizontal = 48.dp, vertical = 8.dp),
        horizontalArrangement = Arrangement.spacedBy(8.dp),
    ) {
        TextLabel(
            state = TextLabelState(
                text = stringResource(Res.string.favorite_sync),
                color = UiKitTheme.colors.color_2,
                textStyle = Large,
            )
        )
        CircularProgressIndicator(
            modifier = Modifier.size(24.dp),
            color = UiKitTheme.colors.color_1,
            strokeWidth = 2.dp,
        )
    }
}
